import React from 'react';
import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';

const Tickets = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent">
          Support Tickets
        </h1>
      </div>

      <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
        <div className="flex flex-col items-center justify-center py-12">
          <Icons.Ticket className="w-16 h-16 text-gray-400 mb-4" />
          <h3 className="text-xl font-semibold text-gray-900 mb-2">Ticket Management</h3>
          <p className="text-gray-600 text-center max-w-md">
            View and manage customer support tickets and inquiries.
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default Tickets;
